import React from "react";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import { withRouter } from "react-router";
import _ from "lodash";
import classnames from "classnames";
import { FormattedMessage } from "react-intl";

import { Autorenew } from "components/Icons";
import { ICustomer, IAccountMessage, IUser } from "models/.";
import AppActions from "../../screens/app/actions";
import SettingsMenu from "./SettingsMenu";
import CustomerModal from "./CustomerModal";
import { URLS, SIDE_MENUS } from "constants/urlConstants";
import getVar from "constants/.";
import { version } from "../../../package.json";

import "./SideMenu.scss";

interface IProps {
  roles: string[];
  customers: ICustomer[];
  getCustomers: () => void;
  location: Location;
  getAccountMessages: () => void;
  accountMessages: IAccountMessage[];
  currentCustomer: any | null;
  user: IUser;
  getRoleIds: () => void;
  getMessageTypes: () => void;
  messageTypes: any;
  onNavigate?: () => void;
}

interface IState {
  isCustomerModalVisible: boolean;
  isRegularUser: boolean;
}

class SideMenu extends React.Component<IProps, IState> {
  constructor(props) {
    super(props);

    this.state = {
      isCustomerModalVisible: false,
      isRegularUser:
        _.get(props, "user.profile.CNBMedewerker", "false") === "false",
    };
  }

  public componentDidMount() {
    this.props.getCustomers();
    this.props.getRoleIds();

    if (this.state.isRegularUser) {
      this.props.getAccountMessages();
      this.props.getMessageTypes();
    }
  }

  public componentWillReceiveProps(nextProps) {
    const { customers, currentCustomer, userName, user } = nextProps;
    const isUserChanged =
      customers.length &&
      (_.isEmpty(currentCustomer) || userName !== _.get(user, "profile.name"));

    if (isUserChanged) {
      this.showCustomerModal(true);
    }
  }

  private showCustomerModal = (isCustomerModalVisible: boolean = false) => {
    this.setState({
      isCustomerModalVisible,
    });
  };

  private getNumberUnread = (type) => {
    const { messageTypes, accountMessages } = this.props;
    const orderedAccMsg = _(accountMessages)
      .filter(["Gezien", false])
      .countBy("TypeId")
      .value();
    const unread = _.get(orderedAccMsg, messageTypes[type], -1);
    return unread;
  };

  public render() {
    const {
      roles,
      customers,
      currentCustomer,
      location: { pathname },
    } = this.props;
    const { isRegularUser } = this.state;
    const profileName = _.get(currentCustomer, "Name", "Geen naam");

    return (
      <div id="side-menu">
        <div className="side-menu-header">
          <SettingsMenu
            profileName={profileName}
            withIcon
            items={[
              {
                name: "CUSTOMER_CHANGE",
                onClick: () => this.showCustomerModal(true),
                renderIcon: () => <Autorenew />,
              },
            ]}
          />
          <CustomerModal
            onCloseModal={this.showCustomerModal}
            visible={this.state.isCustomerModalVisible}
            customers={customers}
          />
        </div>
        <div className="side-menu-content">
          <nav>
            {SIDE_MENUS.map(({ label, items }) => {
              const authItems = _.filter(
                items,
                (item) =>
                  !item.roles ||
                  _.intersection(_.get(item, "roles", []), roles).length > 0
              );

              if (authItems.length === 0) {
                return null;
              }

              return (
                <div key={label}>
                  <FormattedMessage id={label} tagName="h2" />
                  {authItems.map(
                    ({ url, label: subLabel, type = -1, indented }) => (
                      <Link
                        key={subLabel}
                        to={url}
                        onClick={this.props.onNavigate}
                        className={classnames({
                          selected:
                            url !== URLS.HOME_URL && _.includes(pathname, url),
                          indented,
                        })}
                      >
                        <FormattedMessage id={subLabel} />
                        {isRegularUser && this.getNumberUnread(type) > -1 && (
                          <span className="unread">
                            {this.getNumberUnread(type)}
                          </span>
                        )}
                      </Link>
                    )
                  )}
                </div>
              );
            })}
          </nav>
          <div className="copyright">
            {`Copyright @ ${new Date().getFullYear()} CNB (${getVar(
              "ENV_NAME"
            )})`}
            <br />
            {`Version: ${version}`}
            <br />
            <Link to={URLS.PRIVACY_STATEMENT}>Privacy statement</Link>
          </div>
        </div>
      </div>
    );
  }
}

export default withRouter<any>(
  connect(
    (state) => ({
      customers: state.app.customers,
      roles: state.app.roles,
      currentCustomer: state.app.currentCustomer,
      userName: state.app.userName,
      accountMessages: state.app.accountMessages,
      user: state.app.user,
      messageTypes: state.app.messageTypes,
    }),
    {
      getCustomers: AppActions.getCustomers,
      getAccountMessages: AppActions.getAccountMessages,
      getRoleIds: AppActions.getRoleIds,
      getMessageTypes: AppActions.getMessageTypes,
    }
  )(SideMenu)
);
